import { graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import SEO from "components/seo"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"
import Hero from "components/organisms/courses/Hero"
import Info1 from "components/organisms/courses/Info1"
import SchoolCoursesThemes from "components/variants/SchoolCoursesThemes"
import Questions from "components/organisms/courses/Questions"
import Contact from "components/organisms/somebuddy/Contact"

export default function Courses({ pageContext: { currentPage } }) {
  const { schoolPageTitle, ourCustomers } = useTranslations()
  return (
    <div>
      <SEO title={schoolPageTitle} />
      <Hero />
      <Info1 />
      <SchoolCoursesThemes theme="darkyellow" />
      <Contact theme="lightyellow" />
      <Questions />
      <LogoCloudAnimated
        center
        currentPage={currentPage}
        title={ourCustomers}
        rows={2}
      />
    </div>
  )
}

export const pageQuery = graphql`
  query ($locale: String!, $currentPage: String!) {
    allPrismicTestimonial(
      limit: 2
      filter: {
        lang: { eq: $locale }
        data: { show_on_pages: { elemMatch: { page: { eq: $currentPage } } } }
      }
    ) {
      nodes {
        id
        data {
          fact_large {
            text
          }
          fact_small {
            text
          }
          logo {
            url
            alt
          }
          title {
            text
          }
        }
        uid
      }
    }
  }
`
